import enLocale from 'element-ui/lib/locale/lang/en';
// prettier-ignore
export default {
    ...enLocale,
    // 基础
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    cancel: 'Cancel',
    batch_edit: 'Batch Edit',
    title: 'Title',
    desc: 'description',
    path: 'path',
    icon: 'icon',
    permission: 'permission',
    login: 'login',
    logout: 'Logout',
    date: 'Date',
    download: 'Download',
    submit: 'submit',
    reset: 'reset',
    sort: 'sort',
    sure: 'Yes',
    negate: 'No',
    settings: 'Setting',
    component: 'component',
    search: 'Search',
    more: 'More',
    retract: 'Retract',
    download_table: 'Download',
    confirm: 'Confirm',
    role: 'Role',
    email: 'E-mail',
    name: 'Name',
    account: 'Account',
    all: 'All',
    type: 'Type',
    time: 'Time',
    handle: 'handle',
    password: 'Passwod',
    tips: 'Tips',
    past: 'old version',
    cover: 'cover',
    status: 'status',
    // login模块
    module_login: {
        zhaonaxue_admin: 'Zhaonaxue Management Platform',
        title: 'School Management Platform',
        username: 'username',
        password: 'password'
    },

    // cofigure模块
    module_configure: {
        parent_menu: 'parent',
        navigation: 'navigation',
        enable: 'enable',
        absolute: 'absolute address',
        url: 'url',
        placeholder_title: 'please enter a title (no more than 24 characters)',
        placeholder_parent: 'parent menu',
        placeholder_desc: 'description (no more than 100 characters)',
        placeholder_path: 'please enter the path',
        placeholder_icon: 'please fill in the name of the icon',
        placeholder_sort: 'sort (please fill in the numbers)',
        placeholder_permission: 'please select permissions',
        placeholder_url: 'please enter the back-end url',
        placeholder_component: 'please enter the component name',
        warn_title_empty: 'title cannot be empty',
        warn_title_limit: 'up to 24 characters in length',
        warn_desc_empty: 'description cannot be empty',
        warn_desc_limit: 'up to 100 characters in length',
        warn_path_empty: 'path cannot be empty',
        warn_sort_mepty: 'sort cannot be empty',
        warn_sort_limit: 'sort must be number',
        warn_navigation_empty:
            'please choose whether it is a navigation menu or not',
        warn_absolute_empty:
            'please choose whether it is an absolute address or not',
        warn_url_empty: 'URL cannot be empty',
        warn_component_empty: 'component name can not be empty'
    },
    module_settings: {
        update: 'update info',
        change_password: 'change password',
        new_password: 'New Password',
        comfirm_password: 'Comfirm',
        origin_password: 'password'
    },
    module_usage: {
        all: 'all',
        explain: 'explain',
        guide: 'guide',
        update: 'update',
        placeholder: 'please enter module name, title or keyword',
        details: 'details'
    },
    // 跟tab有关
    home: 'Home',
    school_manager: 'School Manager',
    school: 'School',
    selectSchool: 'Select School',
    staff: 'Sfaff',
    parent: 'Parent',
    student: 'Student',
    class: 'Class',
    course: 'Course',
    subject: 'Subject',
    user_manager: 'User Manager',
    daily_manager: 'Daily Manager',
    product_manager: 'Product Manager',
    payment_manager: 'Payment Manager',
    service_manager: 'Service Manager',
    device_manager: 'Device Manager',
    configure_manager: 'Configure Manager',
    configure_routes: 'Routes Configure',
    configure_menu: 'Menu Configure',
    monitor_manager: 'Monitor Manager',
    lab: 'Lab',
    consumption_system: 'Consumption',
    consumption_statistics: 'Statistics',
    consumption_billFlow: 'Financial Details',
    consumption_device: 'Equitment & Limit',
    consumption_account: 'Account Manage',
    consumption_user: 'User Manager',
    bug: 'Bug Store',
    bug_test: 'Bug Test',
    bug_view: 'Bug View',
    usage_desc: 'desc',
    usage_details: 'details',
    auth: 'user & permission',
    auth_permission: 'permission',
    auth_role: 'role',
    product_operation: 'production',
    knowledge_payment: 'knowledge & pay',
    live_room: 'live room',
    members: 'members',
    // 跟动作有关
    close_all: 'Close All',
    close_others: 'Close Other',

    // 跟tools_bar有关
    usage: 'Usage',
    full_screen: 'Full Screen',
    exit_screen: 'Exit',
    change_role: 'Role',
    // home模块
    module_home: {
        help: 'Help Center',
        prod: 'Production',
        pre: 'Release',
        dev: 'Development',
        update: 'recent updates',
        guide: 'novice guide',
        desc: 'description',
        common: 'Common'
    },
    // 消费系统
    module_consume: {
        consume_statistics: 'Comsumption Statistics',
        cash_statistics: 'Cash Statistics',
        day_statistics: 'Statistics Today',
        week_statistics: 'Statistics This Week',
        month_statistics: 'Statistics This Month',
        consumption: 'Consumption',
        top_up: 'Cash Top Up',
        yuan: 'yuan',
        statistics_way: 'Statistics Method',
        date_statistics: 'Date',
        time_statistics: 'Time Slot',
        merchant_statistics: 'Business',
        device_statistics: 'Device',
        user_statistics: 'User',
        set_statistics_range: 'Set Statistics Range',
        set_time_slot: 'Set Time Slot',
        operator_statistics: 'Operator',
        setting_way: 'Setting Method',
        business_set: 'By Business',
        device_set: 'By Device',
        device_need_statistics: 'Need Statistics',
        merchant_need_statistics: 'Need Statistics',
        device_not_statistics: 'Not Need Statistics',
        merchant_not_statistics: 'Not Need Statistics',
        merchant_name: 'Business Name',
        device_name: 'Device Name',
        morning: 'Morning',
        noon: 'Noon',
        afternoon: 'Afternoon',
        evening: 'Evening',
        day_recharge: 'Recharge Today',
        week_recharge: 'Recharge This week',
        month_recharge: 'Recharge This Month',
        recharge_amount: 'Recharge Amount'
    },
    // 筛选项
    module_selectors: {
        all: 'All',
        allSchool: 'All School',
        to: 'To',
        beginning: 'Begining',
        ending: 'Ending',
        daily_statistics: 'Daily Statistics',
        weekly_statistics: 'Weekly Statistics',
        monthly_statistics: 'Monthly Statistics',
        teacher: 'Teacher',
        student: 'Student',
        parents: 'Parent',
        account_balance: 'Account Balance',
        alipay_withholding: 'Alipay Withholding',
        regular_account: 'Regular Account',
        allowance_account: 'Allowance Account',
        default_merchat: 'Default Merchant',
        school: 'School',
        date: 'Date',
        time: 'Time',
        time_unit: 'Time Unit',
        user_type: 'User Type',
        select_device: 'Select Device',
        class: 'Class',
        device: 'Device',
        merchant: 'Business',
        consume_type: 'Consumption Style',
        account_type: 'Account Type',
        operator: 'Operator',
        fund_custody: 'Fund Custody',
        search_user: 'Search User',
        search_input: 'Name or card num',
        cash: 'Cash',
        wechat: 'Wechat',
        alipay: 'Alipay',
        grade: 'Grade',
        rule: 'Rule',
        rule_name: 'Rule Name',
        start_time: 'Start Time',
        end_time: 'End Time',
        identify_state: 'Identify State',
        acquaintance_degree: 'Acquaintance Degree',
        duplicate_removal: 'Duplicate Removal',
        studentID_sort: 'StudentID Sort',
        device_type: 'Device Type',
    },
    // 表格
    module_table: {
        date: 'Date',
        name: 'Full Name',
        class: 'Class',
        user: 'User',
        // 消费系统的表格
        device: 'Device',
        merchant: 'Business',
        consume_income_statistics: 'Consumprion Income Statistics',
        consume_yuan: 'Consumprion(Yuan)',
        consume_time: 'Consumption(Time)',
        refund_expend_statistics: 'Refund Expend Statistics',
        refund_yuan: 'Refund(Yuan)',
        refunt_time: 'Refund(Time)',
        consume_balance: 'Consumption Balance(Yuan)',
        operation: 'Operation',
        details: 'Details',
        cash_income_statistics: 'Cash Income Statistics',
        cash_expend_statistics: 'Cash Expend Statistics',
        topUp_yuan: 'Top Up(Yuan)',
        topUp_time: 'Top Up(Time)',
        cash_withdrawal_yuan: 'Cash Withdrawal(Yuan)',
        cash_withdrawal_time: 'Cash Withdrawal(Time)',
        withdraw_yuan: 'Withdraw Card(Yuan)',
        withdraw_time: 'Withdraw Card(Time)',
        cash_expend_all: 'Cash Expend Statistics(Yuan)',
        cash_balance: 'Cash Balance(Yuan)',
        device_info: 'Device Info',
        location: 'Location',
        business: 'Business',
        user_info: 'User Info',
        card_num: 'Card Number',
        morning_yuan: 'Morning(Yuan)',
        noon_yuan: 'Noonday(Yuan)',
        afternoon_yuan: 'Afternoon(Yuan)',
        evening_yuan: 'Evening(Yuan)',
        total_yuan: 'Total Consumption(Yuan)',
        total_time: 'Total Consumption(Time)',
        weixin_income_statistics: 'WeChat Income Statistics'
    },
    // auth模块
    module_auth: {
        permission_placeholder: 'Please search for permission name',
        role_placeholder: 'Please search for role name',
        authorize: 'authorize',
        configure: 'configure',
        update: 'update',
        delete: 'delete',
        add_permission: 'add permission',
        add_role: 'add role',
        update_permission: 'update permission',
        update_role: 'update role',
        filter_placeholder: 'Enter keywords for filtering',
        permission_parent_name: 'parent',
        role_parent_name: 'parent',
        permission_name: 'permission',
        role_name: 'role',
        placeholder: 'Please enter the content',
        delete_message: 'Are you sure you want to delete it?',
        cancle_message: 'Cancel delete!'
    },
    module_knowledge_payment: {
        school: 'school',
        agent: 'agent',
        all: 'all',
        list: 'School List',
        school_name: 'name',
        school_number: 'number',
        placeholder: 'Please enter keywords',
        free: 'Free',
        charge: 'Charge',
        create: 'new live studio',
        update: 'update live studio',
        name: 'course title',
        desc: 'introduction',
        coupon: 'coupon links',
        url: 'course links',
        cover: 'course cover',
        name_placeholder: 'Please enter the course name (no more than 30 words)',
        desc_placeholder:
            'Please enter the course introduction (no more than 30 words)',
        url_placeholder: 'Please enter the course link',
        coupon_placeholder: 'Please enter the course link',
        cover_message: 'Please upload the cover',
        name_message: 'Please enter the course name.',
        desc_message: 'Please enter the course introduction',
        url_message: 'Please enter the course link',
        coupon_message: 'Please enter a coupon link',
        name_message_max: 'Course Name No More than 30 Words',
        desc_message_max: 'Course Profile No More than 30 Words',
        url_message_max: 'Course links do not exceed 300 words',
        coupon_message_max: 'Coupon links do not exceed 300 words'
    },
    '学校名称：': 'School name:',
    '人脸照片采集说明.': 'face photo collection explanation.',
    '发布中.': 'publishing...',
    '截止时间': 'deadline',
    '发布时间': 'publication time',
    '人脸识别闸门2代:70及其以上版本,低版本的请先升级': 'face recognition gate 2nd generation: version 70 and above, please upgrade if lower version',
    '附件': 'attachment',
    '出错了': 'error occurred',
    '确定移除': 'confirm remove',
    '收费对象': 'billing object',
    '取消时长:': 'cancel duration:',
    '关联公众号': 'associate with official account',
    '对象范围': 'object range',
    '生效时间: ': 'effective time:',
    '恢复激活年限:': 'restore activation period:',
    '播报名称': 'announcement name',
    '人脸录入完毕后,系统会自动录入该': 'after facial recognition is completed, the system will automatically record this',
    '进出设置:': 'entry and exit settings:',
    '考试科目:': 'subject of exam:',
    '已录入:': 'already entered:',
    '科目名称': 'subject name',
    '选择范围': 'select range',
    '收费说明': 'billing explanation',
    '更新`:': 'update `',
    '校园缴费表格模板.': 'campus fee payment table template.',
    '一次识别阈值必须大于': 'single recognition threshold must be greater than',
    '考试名称:': 'exam name:',
    '最小脸部': 'minimum face',
    '进出设置: ': 'entry and exit settings: ',
    '校园卡号': 'campus card number',
    '二次识别活体阈值不能为': 'secondary recognition liveliness threshold cannot be',
    '人脸库同步期间，人脸识别功能不可用。你确定要同步': 'during face library synchronization, face recognition feature is unavailable. Are you sure you want to sync?',
    '通知内容': 'notification content',
    '考试班级:': 'exam class:',
    '生日': 'Birthday',
    '选择文件': 'Select file',
    '批量录入速度:约每10分钟可录入60人': 'Batch input speed: approximately every 10 minutes can enter 60 people',
    '更新': 'Update',
    '激活费用:': 'Activation fee:',
    '学号': 'Student ID',
    '已识别（': 'Identified (',
    '等其他学校人脸录入完毕后,系统会自动录入该': 'After other schools finish facial recognition, the system will automatically enter this',
    '识别阈值': 'Recognition threshold',
    '支持扩展名': 'Supports extension names',
    '最小识别阈值不能为': 'Minimum recognition threshold cannot be',
    '未识别（': 'Unidentified (',
    '发布人': 'Publisher',
    '正在提交.': 'Submitting...',
    '激活时长:': 'Activation duration:',
    '生效时间:': 'Effective time:',
    '通知标题': 'Notification title',
    '性别': 'Gender',
    '分账商户': 'Division merchant',
    '科目': 'Subject',
    '交费规则': 'Fees payment rules',
    '家长数': 'Number of parents',
    '学生总数:': 'Total number of students:',
    '已开启': 'Opened',
    '二次识别阈值不能为': 'Secondary identification threshold cannot be',
    '提交内容失败': 'Submission failed',
    '亲属关系': 'Family relationship',
    '服务错误,请重试': 'Service error, please try again',
    '信息中心': 'Information Center',
    '校务中心': 'School Affairs Center',
    '安全中心': 'Security Center',
    '财务中心': 'Finance Center',
    '设置中心': 'Settings Center',
    '运营中心': 'Operations Center',
    '五育运用': 'Application of Five Education',


    '菜单管理': 'Menu Management',
    '照片名称': 'Photo name',
    '完成': 'Finish',
    '订餐人次': 'Number of people ordering meals',
    '用户管理': 'User Management',
    '学校管理员' : 'School Manager',
    '学校职工' : 'School staff',
    '考试成功！': 'Success in the exam!',
    '排序不能为空': 'Sort cannot be empty',
    '按操作人员统计': 'By operator statistics',
    '人脸识别已开启': 'Face recognition is on',
    '设备与限制': 'Equipment and limitations',
    '温馨提示': 'Kind tips',
    '请先输入分账商户列表的商户号': 'Please enter the merchant number of the account splitting merchant list first',
    '暂无班级数据': 'No class data yet',
    '录入状态': 'Entry Status',
    '操作者': 'Operator',
    '登录': 'Log in',
    '默认商户': 'Default Merchant',
    '按餐次统计': 'Statistics by meal number',
    '父级菜单': 'Parent Menu',
    '添加更多家长': 'Add more parents',
    '缴费管理': 'Payment Management',
    '交费状态': 'Payment status',
    '是否开启收费': 'Is charging enabled?',
    '用户信息': 'User Information',
    '删除门禁': 'Delete access control',
    '孩子所属姓名': 'Child\'s name',
    '后台地址': 'Backend address',
    '选择年级': 'Select grade',
    '删除': 'delete',
    '授权管理': 'Authorization Management',
    '按时就餐人次': 'Number of people dining on time',
    '班级': 'class',
    '无数据': 'No data',
    '充值统计': 'Recharge Statistics',
    '请先输入商户号': 'Please enter the merchant number first',
    '批量录入速': 'Batch input speed',
    '重新下载': 'Re-download',
    '收集': 'collect',
    '导入失败，请修改后重新上传': 'Import failed, please modify and upload again',
    '下载人脸照片采集说明': 'Download Face Photo Collection Instructions',
    '学校管理': 'School Management',
    '科目名称：': 'Course Name:',
    '批量导入历史': 'Batch import history',
    '人脸识别闸门2代：104及其以上版本，低版本的请先升级': 'Face Recognition Gate 2: Version 104 and above, please upgrade to a lower version first',
    '请先输入分账商户列表的商户名称': 'Please enter the merchant name in the account splitting merchant list first',
    '识别时间': 'Identify time',
    '确认提交后，系统将生成账单的支付信息，并修改账单的状态，是否继续执行': 'After confirmation, the system will generate the payment information for the bill and modify the status of the bill.',
    '校园缴费表格模板': 'Campus payment form template',
    '关联公众号：': 'Related public account:',
    '批量录入说明': 'Batch Entry Instructions',
    '不参与': 'Not participating',
    '当前账单已取消收费，无法进行催交': 'The current bill has been cancelled and cannot be urged to pay',
    '上传完成': 'Upload completed',
    '的操作': 'Operation',
    '三次识别阈值': 'Three-time recognition threshold',
    '家长': 'Parents',
    '分账状态': 'Account split status',
    '上传人脸excel文件失败': 'Failed to upload face excel file',
    '的生效时段开始时间必选小于结束时间': 'The effective time period must be less than the end time.',
    '说明': 'illustrate',
    '商户单号': 'Merchant order number',
    '出错了：': 'Something went wrong:',
    '设置成功': 'Set up for success',
    '已识别（BD2）': 'Identified (BD2)',
    '1、照片格式要求': '1. Photo format requirements',
    '退款支出统计': 'Refund expenditure statistics',
    '服务状态（点击修改状态）': 'Service Status (Click to modify status)',
    '历史记录': 'History',
    '校园缴费v1.2_后台_获取商户最大分账比例接口失败': 'Campus Payment v1.2_Backstage_Failed to obtain the maximum merchant split ratio interface',
    '交费状态`': 'Payment status',
    '全部分类': 'All categories',
    '学籍状态': 'Student Status',
    '确认密码': 'Confirm Password',
    '请输入课程简介（不超过30个字）': 'Please enter a course description (no more than 30 words)',
    '更多': 'More',
    '请输入手机号': 'Please enter your phone number',
    '已识别（BD1）': 'Identified (BD1)',
    '详情页': 'Details page',
    '激活学校收费接口失败': 'Failed to activate the school charging interface',
    '请先点击此处': 'Please click here first',
    '请输入二次识别活体阈值': 'Please enter the secondary recognition liveness threshold',
    '初始化': 'initialization',
    '常用功能': 'Common functions',
    '请输入课程名称（不超过30个字）': 'Please enter the course name (no more than 30 characters)',
    '新建直播间': 'Create a new live broadcast room',
    '消费': 'Consumption',
    '组件': 'Components',
    '请先选择发布人': 'Please select a publisher first',
    '已开启：': 'Enabled:',
    '班级管理': 'Class Management',
    '图标': 'icon',
    '学校id': 'School ID',
    '规则名称': 'Rule Name',
    '已批量配置成功': 'Batch configuration has been successful',
    '延时时间': 'Delay time',
    '选择渠道': 'Select Channel',
    '请输入学生姓名': 'Please enter the student\'s name',
    '现金收入统计': 'Cash income statistics',
    '正在添加家长,请勿重复操作!': 'Adding parents, please do not repeat the operation!',
    '邮箱': 'Mail',
    '新手引导': 'Beginner\'s Guide',
    '未录入': 'Not entered',
    '重新上传': 'Re-upload',
    '已过期': 'Expired',
    '已删除': 'Deleted',
    '获取规则详情': 'Get rule details',
    '确定': 'Sure',
    '当前号码存在以下订阅服务': 'The current number has the following subscription services',
    '催交成功，未交费的家长将收到推送提醒': 'The reminder is successful, and parents who have not paid will receive a push reminder',
    '账单已截止，不可操作不参与': 'The bill has expired, no operation, no participation',
    '选择日期时间': 'Select date and time',
    '充值金额': 'Recharge amount',
    '模板背景': 'Template background',
    '发布人：': 'Posted by:',
    '请输入识别阈值': 'Please enter the recognition threshold',
    '数据同步中，稍等片刻点击刷新查看同步情况': 'Data synchronization is in progress. Please wait for a moment and click Refresh to view the synchronization status.',
    '使用中': 'In use',
    '补助账户': 'Subsidy Account',
    '获取配置失败,请刷新重试': 'Failed to obtain configuration, please refresh and try again',
    '金额': 'Amount',
    '请输入功能名称、标题、关键字': 'Please enter the function name, title, keyword',
    '查看批量录入历史': 'View batch entry history',
    '永久': 'permanent',
    '退出登录': 'Log out',
    '未分账': 'Undivided',
    '请先选择代理商': 'Please select an agent first',
    '请选择亲属关系': 'Please select a relative',
    '孩子姓名': 'Child\'s name',
    '直播间': 'Live broadcast room',
    '上传名单': 'Upload List',
    '请先输入通知标题': 'Please enter a notification title first',
    '创建收款码失败': 'Failed to create payment code',
    '请假放行': 'Ask for leave',
    '套餐设置': 'Package settings',
    '登记信息：': 'Registration Information:',
    '正式运营': 'Official operation',
    '3、对于已录入照片的用户，重新录入的话，新照片将会覆盖旧照片。': '3. For users who have already recorded photos, if they re-record them, the new photos will overwrite the old ones.',
    '请选择学生标识': 'Please select your student ID',
    '就餐时间设置': 'Meal time settings',
    '发布成绩': 'Publish Grades',
    '学校未开通微信商户，请联系运营人员开通': 'The school has not opened a WeChat merchant account, please contact the operator to open one',
    '按周统计': 'Statistics by week',
    '请选择适用设备': 'Please select the applicable device',
    '创建账单成功': 'Create bill successfully',
    '考试人': 'Exam Person',
    '同步中': 'Synchronizing',
    '未选择': 'Not selected',
    '统计报表': 'Statistical Reports',
    '无需录入': 'No entry required',
    '元': 'Yuan',
    '退卡(元)': 'Card refund (yuan)',
    '1、选择“用户类型”': '1. Select "User Type"',
    '用户与权限': 'Users and permissions',
    '请输入校园卡号': 'Please enter your campus card number',
    '确认开始批量录入': 'Confirm to start batch entry',
    '系统': 'system',
    '分账状态：': 'Account split status:',
    '请输入token': 'Please enter token',
    '付费专区': 'Paywall',
    '允许进出': 'Access allowed',
    '这是': 'This is',
    '人脸识别闸门：93及其以上版本，低版本的请先升级': 'Face recognition gate: Version 93 and above, please upgrade to a lower version first',
    '排序（请填写数字）': 'Sort (please fill in the number)',
    '上传图片失败': 'Failed to upload image',
    '请输入播报名称': 'Please enter the name of the announcement',
    '孵化中': 'Incubation',
    '六': 'six',
    '请选择用户类型': 'Please select user type',
    '抓拍图片': 'Snap pictures',
    '学校': 'School',
    '共': 'common',
    '未发布': 'Unpublished',
    '处理删除': 'Handling Deletions',
    '关': 'close',
    '女': 'female',
    '晚上消费(元)': 'Night consumption (yuan)',
    '选择用户类型': 'Select User Type',
    '不能为空': 'Cannot be empty',
    '线下支付': 'Offline Payment',
    '标题': 'title',
    '请输入路径': 'Please enter the path',
    '个人设置': 'Personal settings',
    '学生总': 'Total students',
    '考试名称已超出限定的20个字数': 'The exam title exceeds the 20-character limit',
    '首页': 'front page',
    '按设备统计': 'Statistics by device',
    '详情': 'Details',
    '未设置': 'Not set',
    '无匹配数据': 'No matching data',
    '鼠标移动到此处查看目前支持的设备和版本': 'Move your mouse here to view currently supported devices and versions',
    '查找不到设备？鼠标移到此处查看目前支持的设备和版本': 'Can\'t find the device? Move your mouse here to view currently supported devices and versions',
    '不生效日期': 'Ineffective Date',
    '收费名称': 'Charge Name',
    '确定移除 ': 'Confirm removal',
    '充值(次)': 'Recharge(times)',
    '优惠券链接不超过300个字': 'The coupon link should not exceed 300 characters',
    '学校信息管理': 'School Information Management',
    '返回': 'return',
    '当前仅支持docx、xlsx、xls、ppt、pptx、mp4文件的上传': 'Currently only supports uploading docx, xlsx, xls, ppt, pptx, and mp4 files',
    '正在同步': 'Syncing',
    '应用系统': 'Application System',
    '请先输入商户名称': 'Please enter the merchant name first',
    '存在以下订阅服务，暂不允许删除，若要删除，请先取消订阅，并进行退款': 'The following subscription services exist and cannot be deleted at this time. If you want to delete them, please cancel the subscription first and get a refund.',
    '收款码名称不能为空': 'The payment code name cannot be empty',
    '仅刷卡闸门设备有分进和出两个方向，其他设备中': 'Only the card swipe gate device has two directions: entry and exit.',
    '消费收入统计': 'Consumption income statistics',
    '创建账单': 'Create a bill',
    '导入数据': 'Importing Data',
    '人脸识别闸门2': 'Face recognition gate 2',
    '删除中...': 'Deleting...',
    '关闭成功': 'Close Success',
    '科目管理': 'Subject Management',
    '收款码名称：': 'Payment code name:',
    '添加考试': 'Add exam',
    '对象范围：': 'Scope of application:',
    '请输入优惠券链接': 'Please enter the coupon link',
    '请输入商户名称': 'Please enter the merchant name',
    '现金充值': 'Cash Top-up',
    '订餐': 'Order food',
    '账户': 'Account',
    '请输入最短未识别间隔（分钟）': 'Please enter the minimum unrecognized interval (minutes)',
    '当前学生': 'Current Students',
    '请上传封面': 'Please upload a cover',
    '学生姓名最大长度为50个字': 'The maximum length of a student name is 50 characters',
    '就餐时间': 'Meal time',
    '上传文件不能为空': 'Upload file cannot be empty',
    '请上传人脸照片匹配表': 'Please upload the face photo matching table',
    '秒': 'Second',
    '退出全屏': 'Exit full screen',
    '禁止通行': 'No access',
    '分账商户号': 'Split Account Merchant Number',
    '校园缴费表格模板.xlsx': 'Campus payment form template.xlsx',
    '在读': 'Reading',
    '设备类型': 'Device Type',
    '近期更新': 'Recent Updates',
    '确定要删除': 'Confirm to delete',
    '获取成绩科目列表失败, 请刷新重试': 'Failed to obtain the score subject list, please refresh and try again',
    '系统繁忙，请重新上传': 'The system is busy, please upload again',
    '上传人脸照片压缩文件,仅支持zip格式': 'Upload face photo compressed file, only supports zip format',
    '腾讯': 'Tencent',
    '删除科目失败-else, 请刷新重试': 'Failed to delete subject - else, please refresh and try again',
    '关系': 'relation',
    '已识别': 'Identified',
    '收费名称不超过50个字': 'The charge name should not exceed 50 characters',
    '至': 'to',
    '此操作将永久删除该学生, 是否继续?': 'This operation will permanently delete the student, do you want to continue?',
    '操作成功': 'Operation successful',
    '月考': 'Monthly Exam',
    '本日充值': 'Today\'s top-up',
    '已识别（盒）': 'Identified (box)',
    '二维码收费': 'QR code charging',
    '用户': 'user',
    '未绑定': 'Unbound',
    '请选择考试科目': 'Please select the exam subject',
    '服务器繁忙，请刷新重试！': 'The server is busy, please refresh and try again!',
    '数据上传中': 'Data uploading',
    '彩色小摆闸：21及其以上版本，低版本的请先升级': 'Colored small swing gate: Version 21 and above, please upgrade to a lower version first',
    '最短未识别间隔（分钟）': 'Minimum unrecognized interval (minutes)',
    '周六': 'Saturday',
    '无需激活': 'No activation required',
    '分账详情': 'Account split details',
    '删除科目失败-catch, 请刷新重试': 'Failed to delete subject -catch, please refresh and try again',
    '编辑模板': 'Editing a template',
    '添加成功': 'Added successfully',
    '中午消费(元)': 'Lunch consumption (yuan)',
    '家长数：': 'Number of parents:',
    '添加套餐': 'Add a plan',
    '请输入姓名': 'Please enter your name',
    '商品信息': 'Product Information',
    '全部家长': 'All parents',
    '请先选择发布范围': 'Please select the release scope first',
    '孩子所属年级': 'The grade your child is in',
    '删除学生': 'Delete a student',
    '的生效时段': 'Effective time',
    '考试科': 'Examination Section',
    '有效期': 'Validity',
    '登记类型': 'Registration Type',
    '导出结果': 'Export Results',
    '若选择“必交”，则家长必须支付后才能完成账单': 'If you select "Must pay", parents must pay before the bill is completed.',
    '输入抓拍图片链接': 'Enter the link of the captured image',
    '考试时间': 'Exam Time',
    '人脸识别闸门1代：时段内设备暂停更新所有数据；人脸识别闸门2代：时段内设备仅暂停更新人脸数据。': 'Face Recognition Gate 1: The device will suspend updating all data during the period; Face Recognition Gate 2: The device will only suspend updating face data during the period.',
    '门禁规则添加成功': 'Access control rules added successfully',
    '三次识别': 'Three-time recognition',
    '当前账单已截止收费，无法进行催交': 'The current bill has been charged and cannot be urged',
    '未划分年级': 'Not divided into grades',
    '一次只能上传一个excel文件，请删除再上传': 'You can only upload one excel file at a time, please delete it and upload it again',
    '刷新': 'refresh',
    '请先选择学校': 'Please select a school first',
    '消费系统': 'Consumption system',
    '未识别': 'Unrecognized',
    '已识别（TX1）': 'Identified (TX1)',
    '导入成功，': 'Import successful,',
    '接口异常，请稍后重试': 'Interface abnormality, please try again later',
    '当前所处地点': 'Current location',
    '课程管理': 'Course Management',
    '默认设置': 'Default Settings',
    '请输入考试名称': 'Please enter the exam name',
    '获取成绩科目列表失败-catch, 请刷新重试': 'Failed to get the score subject list -catch, please refresh and try again',
    '微信收入统计': 'WeChat income statistics',
    '下载模板': 'Download the template',
    '搜索用户': 'Search for users',
    '监控管理': 'Monitoring and management',
    '人脸识别已关闭': 'Face recognition is off',
    '明细': 'Details',
    '仅支持docx、xlsx、xls、ppt、pptx、mp4文件上传,请重新选择': 'Only supports docx, xlsx, xls, ppt, pptx, mp4 file upload, please reselect',
    '用户类型': 'User Type',
    '同步家长数据': 'Synchronize parent data',
    '类型': 'type',
    '生效中': 'In effect',
    '成功': 'success',
    '条数据同步成功，': 'The data was synchronized successfully.',
    '请选择考试时间': 'Please select the exam time',
    '设置管理': 'Settings Management',
    '所有渠道': 'All channels',
    '一键催交': 'One-click delivery',
    '文本': 'text',
    '请输入正确的学生卡': 'Please enter a valid student ID',
    '学号：': 'Student ID:',
    '学生：全部学生': 'Students: All students',
    '该学校暂未划分年级': 'This school has not yet divided into grades',
    '套餐': 'combo',
    '年级班级': 'Grade Class',
    '规则结束日期': 'Rule end date',
    '免费试听': 'Free trial',
    '结果备注': 'Results Notes',
    '校园卡号：': 'Campus Card Number:',
    '同步年级班级数据': 'Synchronize grade and class data',
    '职工管理': 'Employee Management',
    '请上传格式为xlsx的文件': 'Please upload a file in xlsx format',
    '获取考试详情失败, 请刷新重试': 'Failed to obtain test details, please refresh and try again',
    '考试科目': 'Examination Subjects',
    '通过学生标识订餐': 'Ordering food using your student ID',
    '请选择学校': 'Please select school',
    '取消激活': 'Deactivate',
    '运营人员': 'Operations Staff',
    '分账关系': 'Account sharing relationship',
    '标题不能为空': 'Title cannot be empty',
    '部分交费': 'Partial payment',
    '腾讯库同步': 'Tencent library synchronization',
    '中午': 'noon',
    '请输入大于0的整数': 'Please enter an integer greater than 0',
    '设置统计范围': 'Set the statistics range',
    '截止日期不能为空': 'Deadline cannot be empty',
    '人脸库同步期间，人脸识别功能不可用。你确定要同步？': 'Face recognition is unavailable during face database synchronization. Are you sure you want to synchronize?',
    '请勿重复操作': 'Do not repeat the operation',
    '请添加模板封面': 'Please add a template cover',
    '学校商户关闭分账状态失败': 'The school merchant failed to close the split account status',
    '支持扩展名：.xls .xlsx': 'Supported extensions: .xls .xlsx',
    '帮助中心': 'Help Center',
    '模板标题': 'Template Title',
    '导入结果': 'Import results',
    '批量编辑': 'Batch Edit',
    '支付信息': 'Payment Information',
    '正在导出表格，请勿重复操作': 'The table is being exported. Please do not repeat the operation.',
    '生效时': 'When effective',
    '人脸录入时间': 'Face entry time',
    '职工：': 'staff:',
    '职工姓名': 'Employee Name',
    '发布考试失败, 请刷新重试': 'Failed to publish the exam, please refresh and try again',
    '5、点击“确定”按钮，开始批量导入。': '5. Click the "OK" button to start batch import.',
    '关闭': 'closure',
    '管理平台': 'Management Platform',
    '请搜索权限名称': 'Please search for permission name',
    '职工总数': 'Total number of employees',
    '名单收费': 'List Fees',
    '请先输入分账商户列表的分账比例': 'Please enter the account split ratio of the account split merchant list first',
    '门禁规则': 'Access rules',
    '二次识别阈值不能为0': 'The secondary recognition threshold cannot be 0',
    '三、填写人脸信息匹配表要求': '3. Requirements for filling in the face information matching table',
    '下载': 'download',
    '高': 'high',
    '[舔屏]': '[lick screen]',
    '活体检测': 'Liveness Detection',
    '添加角色': 'Add roles',
    '已暂停': 'Paused',
    '选择算法': 'Choosing an algorithm',
    '期中': 'Midterm',
    '添加科目失败-catch, 请刷新重试': 'Failed to add subject -catch, please refresh and try again',
    '录入照片': 'Enter photos',
    '成绩？': 'score?',
    '人脸库同步提醒': 'Face database synchronization reminder',
    '需要统计的设备': 'Equipment that needs statistics',
    '已失败': 'Failed',
    '一次识别阈值必须大于0': 'The primary recognition threshold must be greater than 0',
    '导入失败，你可以下载导入失败的信息表，修改后重新上传': 'If the import fails, you can download the failed import information table, modify it and upload it again',
    '导出数据': 'Exporting Data',
    '本日统计': 'Today\'s Statistics',
    '查看详情': 'check the details',
    '编辑家长': 'Edit Parent',
    '批量取消订餐': 'Bulk cancellation of orders',
    '保 存': 'save',
    '适用日期': 'Applicable Dates',
    '上传视频不能大于100MB,请重新选择': 'The uploaded video cannot be larger than 100MB, please reselect',
    '分账商户：': 'Split-account merchants:',
    '晚上': 'night',
    '以下用户的人脸同步到腾讯库失败。为不影响人脸识别，请通知对应用户重新录入人脸': 'The following users\' faces failed to be synchronized to the Tencent database. To avoid affecting face recognition, please notify the corresponding users to re-enter their faces.',
    '返回旧版': 'Back to old version',
    '消费统计': 'Consumption Statistics',
    '支付账单': 'Pay your bills',
    '修改': 'Revise',
    '添加模板': 'Add a template',
    '重复周期': 'Repeat cycle',
    '获取考试列表失败, 请刷新重试': 'Failed to obtain the exam list, please refresh and try again',
    '3、按要求采集人脸照片，打成zip压缩包，上传到后台。': '3. Collect facial photos as required, compress them into a zip package, and upload them to the backend.',
    '按日统计': 'Statistics by day',
    '请选择是否为绝对地址': 'Please select whether it is an absolute address',
    '消费方式': 'Consumption method',
    '鼠标移到此处查看支持的设备和版本': 'Move your mouse here to view supported devices and versions',
    '获取导出数据失败，请刷新重试': 'Failed to obtain export data, please refresh and try again',
    '请输入大于0且小于等于350的整数': 'Please enter an integer greater than 0 and less than or equal to 350',
    '选择日期': 'Select Date',
    '提 交': 'submit',
    '添加校园卡': 'Add campus card',
    '上传人脸照片压缩包': 'Upload face photo compressed package',
    '更新`': 'Update',
    '按用户统计': 'By user statistics',
    '确定停止后，当前账单将停止收费，家长无法完成支付，已支付的数据系统将保留，是否继续执行': 'After confirming to stop, the current bill will stop charging, parents will not be able to complete the payment, and the paid data system will retain it. Do you want to continue?',
    '2、下载“采集人脸照片要求、人脸照片信息匹配表”。': '2. Download the "Requirements for Collecting Facial Photos and Facial Photo Information Matching Table".',
    '确认删除该条模板?': 'Are you sure to delete this template?',
    '编辑': 'edit',
    '长度最多为 100 个字符': 'Maximum length is 100 characters',
    '校园管理平台': 'Campus Management Platform',
    '职工：全部职工': 'Employees: All employees',
    '消费(次)': 'Consumption (times)',
    '简介': 'Introduction',
    '识别记录': 'Identify records',
    '发布中...': 'Publishing...',
    '选择商户': 'Select Merchant',
    '允许通行': 'Passage allowed',
    '永久有效': 'Permanent',
    '请先填写通知内容': 'Please fill in the notification content first',
    '等': 'wait',
    '若选择“自愿”，则家长可以选择“不参与”，即完成该账单': 'If you select "Voluntary", parents can choose "Not Participate" to complete the bill.',
    '此操作将删除该家长, 是否继续?': 'This operation will delete the parent, do you want to continue?',
    '调整收费时间': 'Adjust charging time',
    '修改考试失败, 请刷新重试': 'Failed to modify the exam, please refresh and try again',
    '考勤': 'Attendance',
    '描述不能为空': 'Description cannot be empty',
    '添加分账商户': 'Add a split account merchant',
    '微信绑定情况': 'WeChat binding status',
    '剩余激活年': 'Remaining activation years',
    '保存成功': 'Saved successfully',
    '统计方式': 'Statistical method',
    '学籍状态：': 'Student Status:',
    '①请填写职工所属的“照片名称”即可。(如“王校长”，不用填写文件拓展名)': '① Please fill in the "Photo Name" of the employee. (For example, "Principal Wang", no need to fill in the file extension)',
    '请输入用户名或卡号': 'Please enter your username or card number',
    '设置': 'set up',
    '请输入课程简介': 'Please enter a course description',
    '请选择参加考试的班级': 'Please select the class you want to take the exam',
    '需要统计的商户': 'Merchants that need statistics',
    '资金存管': 'Funds custody',
    '迟到就餐人次': 'Number of people late for dining',
    '添加科目名': 'Add subject name',
    '催交': 'Expediting',
    '设置学校收费接口失败': 'Failed to set the school charging interface',
    '课程封面': 'Course Cover',
    '解除绑定': 'Unbind',
    '考试名称': 'Exam Name',
    '本周充值': 'Top up this week',
    '基础信息': 'Basic Information',
    '上传人脸zip文件失败': 'Failed to upload face zip file',
    '请输入app_id': 'Please enter app_id',
    '学生总数': 'Total number of students',
    '确认后，账单状态将修改为“未支付”，学生家长需完成账单的支付，是否继续执行': 'After confirmation, the bill status will be changed to "Unpaid" and the student\'s parents need to complete the payment of the bill.',
    '撤销支付信息': 'Reverse payment information',
    '就餐方式': 'Dining Style',
    '请选择班级': 'Please select class',
    '学生标识': 'Student ID',
    '开启成功': 'Start Success',
    '封面': 'Cover',
    '上传文件': 'Upload files',
    '路径不能为空': 'Path cannot be empty',
    '删除成功!': 'Deleted successfully!',
    '删除失败，请重试': 'Deletion failed, please try again',
    '后门': 'back door',
    '人脸照片匹配表(职工)': 'Face photo matching table (employee)',
    '描述（不超过 100 个字符）': 'Description (up to 100 characters)',
    '学生姓名': 'Student Name',
    '禁止进出': 'No entry or exit',
    '分账金额': 'Amount of account split',
    '确定删除该权限': 'Confirm to delete this permission',
    '背景颜色': 'Background Color',
    '请输入学号': 'Please enter your student number',
    '设备信息': 'Device Information',
    '发布范围': 'Release Scope',
    '学生信息': 'Student Information',
    '请输入组件名': 'Please enter the component name',
    '获取下载数据失败，请刷新重试': 'Failed to obtain download data, please refresh and try again',
    '全选': 'Select All',
    '设备管理': 'Device Management',
    '关 闭': 'closure',
    '未激活': 'Not activated',
    '家长：全部家长': 'Parents: All parents',
    '现金支出合计(元)': 'Total cash expenditure (yuan)',
    '此操作将解除绑定, 是否继续?': 'This operation will unbind, do you want to continue?',
    '获取班级列表失败, 请刷新重试': 'Failed to obtain the class list, please refresh and try again',
    '早上消费(元)': 'Morning consumption (yuan)',
    '选择代理商': 'Choose an Agent',
    '禁用': 'Disable',
    '上传文档不能大于10MB,请重新选择': 'The uploaded file cannot be larger than 10MB, please reselect',
    '上传成功': 'Upload Successfully',
    '小时': 'Hour',
    '一、批量录入人脸步骤': '1. Steps for batch face entry',
    '适用设备': 'Applicable devices',
    '就餐统计': 'Dining Statistics',
    '单元测试': 'Unit Testing',
    '修改直播间': 'Modify live broadcast room',
    '暂无失败数据': 'No failure data',
    '该门禁规则不用生效的特殊日期': 'There is no special date on which this access control rule will take effect.',
    '期末': 'End of term',
    '发布时间：': 'Release time:',
    '建议尺寸：333*206，不超过1M，格式：jpg、jpeg、gif、png': 'Recommended size: 333*206, no more than 1M, format: jpg, jpeg, gif, png',
    '刷脸图片': 'Face scan picture',
    '所选导出数据为0条': 'The selected export data is 0',
    '服务器繁忙，请刷新重试': 'The server is busy, please refresh and try again',
    '数字': 'number',
    '学生管理': 'Student Management',
    '班': 'class',
    '错误详情': 'Error details',
    '\'学校名称：': '\'School Name:',
    '系统ID': 'System ID',
    '下载完成': 'Download Complete',
    '选择设备': 'Select device',
    '请输入密码': 'Please enter your password',
    '配置管理': 'Configuration Management',
    '适用人员': 'Applicable personnel',
    '切换身份': 'Switching identities',
    '付款数': 'Number of payments',
    '已选择': 'Selected',
    '餐次': 'Meals',
    '请填写图标名称': 'Please fill in the icon name',
    '新增公众号': 'Add a new public account',
    '下载人脸照片采集说明、人脸照片信息匹配表': 'Download facial photo collection instructions and facial photo information matching table',
    '状态': 'state',
    '添加': 'Add to',
    '考试班': 'Exam Class',
    '添加家长': 'Add Parent',
    '最大未识别阈值不能小于等于最小识别阈值': 'The maximum unrecognized threshold cannot be less than or equal to the minimum recognized threshold',
    '失败记录': 'Failure Records',
    '修改身份': 'Modify identity',
    '请选择发布人': 'Please select a publisher',
    '操作': 'operate',
    '添加科目失败-else, 请刷新重试': 'Failed to add subject - else, please refresh and try again',
    '请输入内容': 'Please enter content',
    '否': 'no',
    '请选择': 'Please select',
    '请输入收费名称': 'Please enter the name of the charge',
    '选择时间范围': 'Select time range',
    '就餐规则': 'Dining Rules',
    '现金': 'cash',
    '年级班级：': 'Grade and Class:',
    '暂无数据': 'No data yet',
    '进出设': 'In and out',
    '已分账': 'Already accounted',
    '提交内容失败-else': 'Submit content failed-else',
    '规则名称最长20个字，请重新填写': 'The rule name is up to 20 characters long, please fill it in again',
    '固定金额': 'Fixed amount',
    '考试班级': 'Exam Class',
    '撤销后，线下支付的支付信息将会清除且不能恢复，是否继续': 'After cancellation, the payment information of offline payment will be cleared and cannot be restored. Do you want to continue?',
    '商户配置修改成功': 'Merchant configuration modified successfully',
    '请输入学生卡': 'Please enter your student ID',
    '暂不允许删除，若要删除，请先取消以下订阅': 'Deletion is not allowed at the moment. If you want to delete, please cancel the following subscription first.',
    '1、请填写学生所属的“照片名称”即可。(如“小明”，不用填写文件拓展名)': '1. Please fill in the "Photo Name" of the student. (For example, "Xiao Ming", no need to fill in the file extension)',
    '选择范围：': 'Select range:',
    '账户余额': 'Account Balance',
    '发布': 'release',
    '选填项，选择家长': 'Optional, select Parent',
    '输入模板标题，不超过40个字': 'Enter the template title, no more than 40 characters',
    '批量订餐': 'Bulk ordering',
    '选填项，选择职位': 'Optional, select position',
    '识别阈值：': 'Identification threshold:',
    '查看结果': 'View Results',
    '周': 'week',
    '本周统计': 'Statistics of the Week',
    '请选择学籍状态': 'Please select your student status',
    '收费截止时间修改成功': 'The charging deadline has been modified successfully',
    '订单号': 'Order Number',
    '请选择代理商': 'Please select an agent',
    '请输入': 'Please enter',
    '取消': 'Cancel',
    '按时段统计': 'Statistics by time period',
    '取现(次)': 'Cash withdrawal (times)',
    '请选择年级': 'Please select grade',
    '规则更新成功': 'Rule update successful',
    '标记': 'mark',
    '自愿': 'voluntary',
    '手机号码*': 'phone number*',
    '搜索': 'search',
    '全部': 'all',
    '生效时段': 'Effective period',
    '已取消': 'Cancelled',
    '姓名': 'Name',
    '代理商名称：': 'Agent Name:',
    '按月统计': 'Statistics by month',
    '收费说明：': 'Charges:',
    '闸门设备：63及其以上版本，低版本的请先升级': 'Gate device: Version 63 and above, please upgrade the lower version first',
    '创建日期': 'Creation Date',
    '修改密码': 'Change Password',
    '姓名：': 'Name:',
    '时间段设置有重叠，请检查后重新保存': 'The time period settings overlap, please check and save again',
    '期间的支付记录': 'Payment records during the period',
    '的重复周期': 'Repeat cycle',
    '服务管理': 'Service Management',
    '操作失败,未查询到': 'Operation failed, not found',
    '消费(元)': 'Consumption (yuan)',
    '全部职工': 'All employees',
    '流水记录': 'Transaction records',
    '删除全部门禁规则后，才允许切换': 'After deleting all the gate ban rules, switching is allowed',
    '已发布': 'Published',
    '按商户设置': 'By merchant settings',
    '支付宝': 'Alipay',
    '请选择权限': 'Please select permissions',
    '模板封面': 'Template cover',
    '按设备设置': 'Per device settings',
    '获取年级班级列表失败, 请刷新重试': 'Failed to obtain the grade and class list, please refresh and try again',
    '卡号': 'card number',
    '项目名称': 'Project Name',
    '微信单号': 'WeChat order number',
    '请输入考试名称，不超过20个字': 'Please enter the exam name, no more than 20 characters',
    '●照片支持jpg. jpeg. png格式， 要求不小于800*800像素。': '●Photos must be in jpg, jpeg, and png formats and must be no smaller than 800*800 pixels.',
    '绝对地址': 'Absolute address',
    '所有': 'all',
    '金额类型': 'Amount Type',
    '关联公众号信息不全，请先补充完整': 'The information of the associated public account is incomplete, please complete it first',
    '商户名称': 'Merchant Name',
    '上传填写后的人脸照片匹配表,仅支持xlsx格式': 'Upload the completed face photo matching form, only supports xlsx format',
    '个文件': 'Files',
    '操作失败, 请刷新重试': 'Operation failed, please refresh and try again',
    '同步学生数据': 'Synchronize student data',
    '模拟': 'simulation',
    '确定催交后，系统将发送账单的推送提醒给未交费的家长用户，1天内仅能催交1次，是否继续执行': 'After confirming the reminder, the system will send a push notification to the parent who has not paid. You can only remind them to pay once a day. Do you want to continue?',
    '上传名单(支持按单个学生设置不同收费金额)': 'Upload the list (supports setting different fee amounts for each student)',
    '提交': 'submit',
    '请先选择用户类型': 'Please select the user type first',
    '功能说明': 'Functional Description',
    '人脸识别': 'Face Recognition',
    '添加规则': 'Adding rules',
    '请等待压缩包或匹配表文件上传完成，再进行该切换': 'Please wait until the compressed package or match table file is uploaded before switching.',
    '未就餐人次': 'Number of people who did not dine',
    '批量录入操作': 'Batch Entry Operation',
    '③填写表格时， 请勿修改“系统ID、孩子所属年级、孩子所属班级、孩子姓名、家长手机号”。': '③When filling in the form, please do not modify the "system ID, child\'s grade, child\'s class, child\' s name, parent\'s mobile phone number".',
    '毕业': 'graduate',
    '请选择要搜索的学校': 'Please select the school you want to search',
    '密码': 'password',
    '学校列表': 'School List',
    '播报名称最大长度为20个字': 'The maximum length of the announcement name is 20 characters',
    '获取导出数据失败, 请刷新重试': 'Failed to obtain export data, please refresh and try again',
    '课程链接不超过300个字': 'The course link should not exceed 300 words',
    '●被拍摄者需要平视镜头，不准低头歪头，眼睛眉毛需要清晰可见，头发不准遮挡到眉毛。': '●The person being photographed needs to look straight at the camera, and is not allowed to lower or tilt his head. His eyes and eyebrows need to be clearly visible, and his hair is not allowed to cover his eyebrows.',
    '模板分类': 'Template Classification',
    '请上传格式为zip的文件': 'Please upload a zip file',
    '请选择日期': 'Please select date',
    '④对于已录入照片的职工，重新录入的话，新照片将会覆盖旧照片。': '④ For employees whose photos have been entered, if they re-enter the photos, the new photos will overwrite the old ones.',
    '支付金额': 'Payment amount',
    '排序必须为数字值': 'The sort value must be a numeric value',
    '选填项': 'Optional',
    '收费项目金额不能为0，请修改': 'The amount of the charging item cannot be 0, please modify it',
    '收费截止时间调整为': 'The payment deadline is adjusted to',
    '该次考试存在未录入成绩的学生，请检查': 'There are students whose scores have not been entered in this exam. Please check',
    '选填项，选择考勤标签': 'Optional, select the Attendance tab',
    '代理商': 'Agents',
    '主号': 'Main Number',
    '设置消费时段': 'Set consumption time',
    '设备': 'equipment',
    '请填写一次识别阈值': 'Please fill in the primary recognition threshold',
    '家长信息': 'Parent Information',
    '一次识别': 'One-time recognition',
    '请先选择年级': 'Please select grade first',
    '模板内容': 'Template Contents',
    '当前账号没有权限访问此页面，请用指定账号查看': 'The current account does not have permission to access this page. Please use a specified account to view it.',
    '学校名称': 'School Name',
    '开启': 'Open',
    '组件名不能为空': 'Component name cannot be empty',
    '已关闭': 'Closed',
    '黑名单': 'blacklist',
    '商户号': 'Merchant Number',
    '已结束': 'Ended',
    '成绩表': 'Results',
    '暂无可用设备': 'No devices available',
    '排序': 'Sorting',
    '前门': 'Front door',
    '收费对象：': 'Charges:',
    '家长总数': 'Total number of parents',
    '请选择年级班级': 'Please select grade class',
    '知识付费': 'Knowledge payment',
    '●照片名称不要带有空格，最长不要超过40个字,如“小明”。': '●The photo name should not contain spaces and should not exceed 40 characters, such as "Xiao Ming".',
    '陈小峰': 'Chen Xiaofeng',
    '账单已停止收费': 'The bill has stopped charging',
    '其它设备暂不支持，请到旧版后台设置门禁规则': 'Other devices are not supported yet. Please go to the old version backend to set access control rules.',
    '男': 'male',
    '个班级': 'Classes',
    '是否确认删除': 'Confirm deletion',
    '线上支付': 'Online Payment',
    '识别状态': 'Identify status',
    '家长管理': 'Parent Management',
    '时间单位': 'Time Unit',
    '[坏笑]': '[smirk]',
    '等其他学校人脸录入完毕后,系统会自动录入该“': 'After the face entry of other schools is completed, the system will automatically enter the "',
    '添加科目': 'Add Subject',
    '输入照片名称、学生姓名': 'Enter photo name, student name',
    '时间间隔不能超过30天': 'The time interval cannot exceed 30 days',
    '校园卡信息': 'Campus Card Information',
    '获取学校服务收费列表接口失败': 'Failed to obtain the school service fee list interface',
    '早上': 'Morning',
    '提交内容失败-catch': 'Submit content failed-catch',
    '查询时间': 'Query time',
    '退款(次)': 'Refund(times)',
    '收费设置': 'Fee Settings',
    '正在删除学生,请勿重复操作!': 'Deleting students, please do not repeat the operation!',
    '上传的图片最大尺寸为750*319!': 'The maximum size of the uploaded image is 750*319!',
    '上传失败，表格内容与模板格式不符，请修改后重新上传': 'Upload failed. The table content does not match the template format. Please modify and upload again.',
    '是否开启分账': 'Whether to enable split account',
    '二、采集人脸照片要求': 'II. Requirements for collecting facial photos',
    '开始日期': 'start date',
    '确认后，该学生的账单状态将修改为“不参与”并完成账单，是否继续执行': 'After confirmation, the student\'s billing status will be changed to "Not Participating" and the bill will be completed. Do you want to continue?',
    '添加权限': 'Add permissions',
    '商户配置': 'Merchant Configuration',
    '延迟时间': 'Delay time',
    '导出': 'Export',
    '视频文件大小不超过100M，文档文件大小不超过10M': 'The video file size should not exceed 100M, and the document file size should not exceed 10M',
    '激活': 'activation',
    '孩子所属班级': 'The class your child belongs to',
    '分账比例': 'Account sharing ratio',
    '本月充值': 'Top up this month',
    '正在编辑家长,请勿重复操作!': 'Editing parents, please do not repeat the operation!',
    '收费名称不能为空': 'Charge name cannot be empty',
    '权限管理': 'Permission Management',
    '未识别（BD2）': 'Unidentified (BD2)',
    '播报名称：': 'Announcement Name:',
    '课程链接': 'Course Link',
    '等待中': 'Waiting',
    '手机主号': 'Mobile phone number',
    '手机号码：': 'phone number:',
    '结束时间': 'End time',
    '总分分值': 'Total score',
    '原密码': 'Original password',
    '身份': 'identity',
    '请输入完整姓名': 'Please enter your full name',
    '账户类型': 'Account Types',
    '未识别（BD1）': 'Unidentified (BD1)',
    '确 定': 'Sure',
    '请输入模板标题': 'Please enter a template title',
    '收款码': 'Payment code',
    '校园缴费v1.2_后台_学校商户配置列表接口失败': 'Campus Payment v1.2_Backstage_School Merchant Configuration List Interface Failed',
    '所选年级中不存在班级，请先前往添加': 'There is no class in the selected grade, please add it first',
    '更新学校收费开关接口失败': 'Failed to update the school fee switch interface',
    '分账商户的分账比例总和不能超过': 'The total share ratio of the account-sharing merchants cannot exceed',
    '常规账户': 'Regular Account',
    '去选择': 'Go to select',
    '收款码名称': 'Payment code name',
    '商户': 'Merchants',
    '未支付': 'Not paid',
    '账单详情': 'Bill Details',
    '通知内容：': 'Notification content:',
    '最小脸部：': 'Minimal face:',
    '人脸库同步': 'Face database synchronization',
    '选择分类': 'Select Category',
    '获取年级列表失败请刷新重试': 'Failed to obtain the grade list, please refresh and try again',
    '请上传人脸照片压缩包': 'Please upload a compressed package of face photo',
    '性别：': 'gender:',
    '长度最多为 24 个字符': 'Maximum length is 24 characters',
    '④对于已录入照片的家长，重新录入的话，新照片将会覆盖旧照片。': '④For parents who have already entered photos, if they re-enter, the new photos will overwrite the old ones.',
    '照片': 'photo',
    '●不要在逆光、强光、阴暗的环境拍摄照片，不要二次翻拍已有的人脸照片。': '●Do not take photos in backlit, strong light, or dark environments, and do not take existing photos of faces a second time.',
    '课程名称不超过30个字': 'The course title should not exceed 30 characters.',
    '全部学生': 'All students',
    '日期': 'date',
    '只出不进': 'Only out, no in',
    '已成功上传该附件': 'The attachment has been uploaded successfully',
    '①请填写家长所属的“照片名称”即可。(如“李妈妈”，不用填写文件拓展名)': '① Please fill in the "Photo Name" of the parent. (For example, "Mother Li", no need to fill in the file extension)',
    '①请填写学生所属的“照片名称”即可。(如“小明”，不用填写文件拓展名)': '① Sila isikan "nama foto" ibu bapa. (Sebagai contoh, "Ming Xiao", tidak perlu mengisi sambungan fail)',
    '无': 'none',
    '请选择是否为导航菜单': 'Please select whether it is a navigation menu',
    '订餐人数': 'Number of people ordering',
    '日': 'day',
    '发布成功': 'Published successfully',
    '收费名称：': 'Charge Name:',
    '请选择要添加考试的学校': 'Please select the school to add the exam to',
    '消费合计(元)': 'Total consumption (yuan)',
    '已交费': 'Fees paid',
    '产品管理': 'Product Management',
    '未知': 'unknown',
    '预计还需': 'It is expected to take',
    '微信': 'WeChat',
    '创建时间': 'Creation time',
    '门禁动作': 'Access control action',
    '请选择渠道': 'Please select a channel',
    '请输入商户号': 'Please enter the merchant number',
    '下载失败记录': 'Download failure records',
    '按日期统计': 'Statistics by date',
    '一': 'one',
    '人脸识别闸门1代：支持全部版本': 'Face Recognition Gate 1: Support all versions',
    '人脸录入完毕后,系统会自动录入该“': 'After the face entry is completed, the system will automatically enter the "',
    '请搜索角色名称': 'Please search for the role name',
    '输入关键字进行过滤': 'Enter keywords to filter',
    '三': 'three',
    '描述': 'describe',
    '人脸识别闸门2代：91及其以上版本，低版本的请先升级': 'Face Recognition Gate 2: Version 91 and above, please upgrade to a lower version first',
    '请填写模板内容': 'Please fill in the template content',
    '校园缴费v1.2_后台_分账关系列表接口失败': 'Campus Payment v1.2_Background_Account Relationship List Interface Failed',
    '同步结果': 'Synchronization results',
    '附件：': 'appendix:',
    '未识别（TX1）': 'Unidentified (TX1)',
    '暂无年级数据': 'No grade data yet',
    '请先选择代理商或者学校': 'Please select an agent or school first',
    '通知标题：': 'Notice Title:',
    '选择名单': 'Select List',
    '创建收款码': 'Create a payment code',
    '宿舍': 'dormitory',
    '不需要统计的设备': 'Equipment that does not require statistics',
    '老师': 'teacher',
    '所有代理商': 'All Agents',
    '选择文件失败,请刷新重试': 'Failed to select file, please refresh and try again',
    '个': 'indivual',
    '相似度': 'Similarity',
    '未识别相似度': 'Unidentified similarity',
    '路由配置': 'Routing Configuration',
    '二次识别活体阈值': 'Secondary identification liveness threshold',
    '是': 'yes',
    '请输入收款码名称': 'Please enter the payment code name',
    '请输入正确的手机号': 'Please enter a valid phone number',
    '未交费': 'Unpaid Fees',
    '所有学校': 'All schools',
    '只进不出': 'Only in, no out',
    '正在上传，请勿重复点击': 'Uploading, please do not click again',
    '学生姓名：': 'Student Name:',
    '一次只能上传一个zip文件，请删除再上传': 'You can only upload one zip file at a time, please delete it and upload it again',
    '对象范围不能为空': 'Object range cannot be empty',
    '收费项目：': 'Fees:',
    '相似人': 'Similar people',
    '温馨提示：若是开启人脸收费业务的学校，请先确认学生的剩余可用人脸数量。': 'Warm reminder: If your school has enabled facial recognition payment service, please first confirm the remaining number of available faces for students.',
    '点击上传': 'Click Upload',
    '获取年级列表失败, 请刷新重试': 'Failed to obtain grade list, please refresh and try again',
    '开始时间': 'Start time',
    '删除成功': 'Deleted successfully',
    '●将采集的照片,全部放在1个文件夹里,打包成zip压缩包': '●Put all the collected photos in one folder and package them into a zip archive',
    '现金统计': 'Cash Statistics',
    '请填写规则名称': 'Please fill in the rule name',
    '账单状态': 'Billing Status',
    '操作人员': 'Operator',
    '不超过50个字': 'No more than 50 characters',
    '开通会员': 'Sign up for membership',
    '批量配置': 'Batch Configuration',
    '进行中': 'in progress',
    '录入失败': 'Entry failed',
    '最小识别阈值不能为0': 'The minimum recognition threshold cannot be 0',
    '请添加模板背景': 'Please add a template background',
    '科目？': 'suject?',
    '研发中': 'Under development',
    '其它设备暂不支持': 'Other devices are not supported yet',
    '日常运营管理': 'Daily operations management',
    '用户填写': 'User fill in',
    '挂失': 'Report Lost',
    '该考试你已经发布过, 不能再发布': 'You have already published this exam. You cannot publish it again.',
    '下午消费(元)': 'Afternoon consumption (yuan)',
    '关闭所有': 'Close All',
    '修改权限': 'Modify permissions',
    '激活时': 'When activated',
    '上传的图片最大尺寸为333*206!': 'The maximum size of the uploaded image is 333*206!',
    '考试类型': 'Exam Type',
    '选择一次识别算法': 'Select a recognition algorithm',
    '登记信息不全，请先补充完整': 'The registration information is incomplete, please complete it first',
    '学生': 'student',
    '年': 'Year',
    '周日': 'Sunday',
    '请输入课程链接': 'Please enter the course link',
    '批量': 'batch',
    '休学': 'Suspension of study',
    '消费收支结余(元)': 'Consumption balance (yuan)',
    '必填项': 'Required fields',
    '下载表格': 'Download Form',
    '发布范围：': 'Release Scope:',
    '取 消': 'Cancel',
    '本月统计': 'Statistics for this month',
    '已截止': 'Expired',
    '取消时': 'When cancelling',
    '二': 'two',
    '支付方式': 'Payment Methods',
    '停止': 'stop',
    '请输入标题（不超过 24 个字符）': 'Please enter a title (up to 24 characters)',
    '设备类型：': 'Device Type:',
    '请输入关键词': 'Please enter keywords',
    '周一': 'on Monday',
    '取现(元)': 'Cash withdrawal (yuan)',
    '下午': 'afternoon',
    '五': 'five',
    '设置方式': 'How to set it up',
    '上传文件失败': 'Failed to upload file',
    '请先选择渠道': 'Please select a channel first',
    '2、拍摄场景要求': '2. Shooting scene requirements',
    '请输入标题，不超过50个字': 'Please enter a title, no more than 50 characters',
    '选择文件：': 'Select File:',
    '创建平台': 'Create a platform',
    '选择班级': 'Select Class',
    '请添加背景颜色': 'Please add background color',
    '请稍后重试': 'Please try again later',
    '学生：': 'student:',
    '周三': 'Wednesday',
    '若为“必交”则默认勾选，且不可取消勾选，家长必须支付此项；若为“选交”，则家长可自由勾选并支付': 'If it is "Required", it will be checked by default and cannot be unchecked. Parents must pay this item; if it is "Optional", parents can check and pay freely.',
    '二次识别': 'Secondary Identification',
    '激活费': 'Activation fee',
    '时间': 'time',
    '请输入完整相似度值': 'Please enter the complete similarity value',
    '行数': 'Number of rows',
    '已取消删除': 'Undeleted',
    '文档不能大于1MB,请重新选择': 'The document cannot be larger than 1MB, please reselect',
    '分钟,请耐心等待': 'Minutes, please wait patiently',
    '年级': 'grade',
    '人': 'people',
    '全部设备': 'All Equipment',
    '正在下载数据': 'Downloading data',
    '三次次识别活体阈值': 'Three-time liveness recognition threshold',
    '拼命加载中': 'Loading',
    '2、请勿修改表格模板已有的信息和格式。': '2. Please do not modify the existing information and format of the form template.',
    '正在添加学生卡,请勿重复操作!': 'Adding student card, please do not repeat the operation!',
    '请选择模板分类': 'Please select a template category',
    '危险区域': 'Dangerous areas',
    '启用': 'Enable',
    '成绩': 'score',
    '就餐人次': 'Number of diners',
    '即可': 'You can',
    '权限配置': 'Permission Configuration',
    '家长：': 'Parents:',
    '四': 'Four',
    '确定后系统将执行同步': 'After confirmation, the system will perform synchronization',
    '该学校还没添加任何职工': 'This school has not added any staff yet',
    '正在请求数据': 'Requesting data',
    '是否默认背景': 'Is the background the default?',
    '人脸闸门暂停更新数据时段': 'Face Gate data update suspension period',
    '3、打压缩包要求': '3. Requirements for compressing the package',
    '课程简介不超过30个字': 'Course description should not exceed 30 words',
    '请求规则默认设置': 'Request rule defaults',
    '条数据同步失败': 'Failed to synchronize data',
    '导航菜单': 'Navigation Menu',
    '数据正在导入中，请不要离开当前页面': 'The data is being imported, please do not leave the current page',
    '不需要统计的商户': 'Merchants who do not need statistics',
    '分账状态修改失败': 'Failed to modify the split account status',
    '生日：': 'Birthday:',
    '结束日期': 'End Date',
    '亲属关系：': 'Relationship:',
    '手机号': 'Phone number',
    '请求规则列表': 'Request rule list',
    '仅支持jpg、jpeg、gif、png件的上传,请重新选择': 'Only supports uploading jpg, jpeg, gif, png files, please reselect',
    '二次识别活体阈值不能为0': 'The secondary liveness identification threshold cannot be 0',
    '下载人脸照片匹配表': 'Download face photo matching table',
    '获取班级列表失败请刷新重试': 'Failed to obtain the class list, please refresh and try again',
    '开': 'open',
    '支付宝代扣': 'Alipay debit',
    '收费项目信息不全，请先补充完整': 'The charging item information is incomplete, please complete it first',
    '到期时间': 'Expiration time',
    '人脸照片采集说明.docx': 'Face_photo_collection_instructions.docx',
    '收起': 'Close',
    '保存': 'save',
    '截止时间：': 'Deadline:',
    '职工': 'staff',
    '正在上传': 'Uploading',
    '创建人': 'Founder',
    '请等待匹配表文件上传完成，再进行该切换': 'Please wait for the match table file to be uploaded before making this switch',
    '●干净纯色的照片背景为佳，推荐使用纯白色背景。(近肤色的背景除外)': '●A clean, pure-color photo background is preferred. A pure white background is recommended. (Except for backgrounds close to skin color)',
    '新密码': 'New Password',
    '周五': 'Friday',
    '学生姓名*': 'Student Name*',
    '请填写门禁规则的结束日期或设置为永久生效': 'Please fill in the end date of the access control rule or set it to be permanent',
    '请输入最小识别阈值': 'Please enter the minimum recognition threshold',
    '程序错误，请稍后再试': 'Program error, please try again later',
    '周二': 'Tuesday',
    '上传人脸照片匹配表': 'Upload face photo matching table',
    '优惠券链接': 'Coupon Link',
    '支付时间': 'Payment Time',
    '4、在人脸照片匹配表填写“照片名称”后,上传到后台。': '4. Fill in the "Photo Name" in the face photo matching table and upload it to the backend.',
    '关闭其他': 'Close Other',
    '商户名称：': 'Merchant Name:',
    '按商户统计': 'By merchant statistics',
    '不额外放行请假用户': 'No additional leave users are allowed',
    '手机号码': 'phone number',
    '更新资料': 'Update',
    '添加门禁动作': 'Add access control actions',
    '商户号：': 'Merchant Number:',
    '录入结果': 'Input results',
    '已录入': 'Already entered',
    '重置': 'Reset',
    '待分账': 'Awaiting payment',
    '若为“必交”则默认勾选，且不可取消勾选，家长必须支付此项；若为“选交”，则家长可自由勾选并支付。最多可添加10个收费项目': 'If it is "Required", it will be checked by default and cannot be unchecked. Parents must pay this item; if it is "Optional", parents can check and pay freely. Up to 10 charging items can be added',
    '单选': 'Single Choice',
    '权限': 'Permissions',
    '条': 'strip',
    '退卡(次)': 'Card return (times)',
    '人脸照片匹配表(家长)': 'Face Photo Matching Table (Parents)',
    '路径': 'path',
    '请输入课程名称': 'Please enter the course name',
    '提示': 'hint',
    '幼儿园刷卡机：160及其以上版本，低版本的请先升级': 'Kindergarten card reader: Version 160 and above, please upgrade to a lower version first',
    '当前所属商户': 'Current merchant',
    '+添加模板': '+ Add Template',
    '退款(元)': 'Refund (yuan)',
    '请刷新重试': 'Please refresh and try again',
    '请选择学生性别': 'Please select the student\'s gender',
    '必交': 'Must pay',
    '监听': 'monitor',
    '人脸照片匹配表(学生)': 'Face photo matching table (student)',
    '周四': 'Thursday',
    '请填写门禁动作': 'Please fill in the access control action',
    '请选择考试类型': 'Please select the exam type',
    '现金收支结余(元)': 'Cash balance (yuan)',
    '就餐状态': 'Dining status',
    '选择学校': 'Choose a school',
    '保密': 'Confidentiality',
    '地点': 'Place',
    '已激活': 'Activated',
    '支付': 'Payment',
    '进出设置': 'In and Out Settings',
    '抓拍照片': 'Snap photos',
    '默认允许所有人进出': 'By default, everyone is allowed to enter and exit',
    '学生标识：': 'Student ID:',
    '家长手机号': 'Parent\' s mobile phone number',
    '展示': 'exhibit',
    '未添加收费项目，请先添加后提交': 'No charging items have been added, please add them before submitting',
    '现金支出统计': 'Cash expenditure statistics',
    '正在下载': 'Downloading',
    '获取编辑的内容失败': 'Failed to obtain the edited content',
    '默认禁止所有人进出': 'By default, no one is allowed to enter or exit',
    '全部状态': 'All Status',
    '已录': 'Recorded',
    '请假用户将允许在设置的时段内被放行': 'The user who requests leave will be allowed to leave within the set time period',
    '选交': 'Select',
    '录入成功': 'Successful entry',
    '学校人数': 'School population',
    '永久生效': 'Permanent',
    '输入照片名称、职工姓名': 'Enter photo title, employee name',
    '添加考试失败, 请重试': 'Failed to add exam, please try again',
    '请输入后台地址': 'Please enter the background address',
    '今日已发起过催交提醒，请明天再执行催交操作': 'A reminder has been issued today. Please try again tomorrow.',
    '收费项目': 'Fees',
    '账户管理': 'Account Management',
    '人员去重': 'Personnel deduplication',
    '请重试': 'Please try again',
    '③填写表格时， 请勿修改“系统ID、手机号、职工姓名”。': '③When filling in the form, please do not modify the "system ID, mobile phone number, employee name".',
    '交费规则：': 'Payment rules:',
    '输入照片名称、孩子所属姓名': 'Enter the photo name and the name of the child',
    '充值(元)': 'Recharge (Yuan)',
    '消费合计(次)': 'Total consumption (times)',
    '人脸库图片': 'Face library pictures',
    '取消激活学校收费接口失败': 'Failed to deactivate the school charging interface',
    '访客': 'Visitors',
    '配置': 'Configuration',
    '建议尺寸：750*319，不超过1M，格式：jpg、jpeg、gif、png': 'Recommended size: 750*319, no more than 1M, format: jpg, jpeg, gif, png',
    '该学校暂无识别记录！': 'There is no identification record for this school!',
    '数据加载中': 'Data loading',
    '当前表格有': 'The current table has',
    '实验室': 'laboratory',
    '校园缴费v1.2_后台_获取分账默认设置接口失败': 'Campus Payment v1.2_Background_Getting the default settings interface for split accounts failed',
    '②请勿修改表格模板格式。': '②Please do not modify the form template format.',
    '产品运营': 'Product Operations',
    '默认': 'default',
    '请输入最大识别阈值': 'Please enter the maximum recognition threshold',
    '正在提交...': 'Submitting...',
    '百度': 'Baidu',
    '测试': 'test',
    '考试名': 'Exam Name',
    '请等待压缩包文件上传完成，再进行该切换': 'Please wait for the compressed file to be uploaded before switching.',
    '全屏': 'full screen',
    '规则开始日期': 'Rule start date',
    '恢复激活年': 'Reactivation Year',
    '登记信息': 'Registration Information',
    '二次识别阈值': 'Secondary identification threshold',
    '不超过15个字': 'No more than 15 characters',
    '角色管理': 'Role Management',
    '账单已开启收费': 'Billing has started',
    '成绩管理' : 'Performance Management',
    '通知模板' : 'Notification template',
    '【家长】仅针对带人脸识别功能的设备有效，其他设备可以不用设置' : '[Parents] Only for devices with face recognition function effective, other devices can not be set',
    '月': 'month',
    '批量录入人脸': 'Batch face recording',
    '学校商户配置': 'School merchant allocation',

    '职工管理 (新版)': 'Employee Management (New Version)',
    '学生管理（新版）': 'Student Management (New Version)',
    '模拟刷卡': 'Simulate Card Swiping',
    '支付宝模拟登陆': 'Alipay Simulated Login',
    '微信模拟登录': 'WeChat Simulated Login',
    '回收站': 'Recycle Bin',
    '通知公告': 'Notice Announcement',
    '查看': 'View',
    '班级排序': 'Class Sorting',
    '作业': 'Homework',
    '作业列表': 'Homework List',
    '发布作业': 'Publish Homework',
    '通知发布': 'Notice Release',
    '接收记录': 'Receiving Record',
    '异常列表': 'Exception List',
    '关键字列表': 'Keyword List',
    '萌萌圈查看': 'Meng Meng Circle View',
    '萌萌圈待审核列表': 'Meng Meng Circle Pending Review List',
    '萌萌圈评论待审核列表': 'Meng Meng Circle Comment Pending Review List',
    '显示范围设置': 'Display Range Setting',
    '视频查看': 'Video Viewing',
    '学生自主审核列表': 'Student Self-review List',
    '成长记录': 'Growth Record',
    '我的学校': 'My School',
    '学校简介': 'School Introduction',
    '学校新闻': 'School News',
    '新闻列表': 'News List',
    '新闻发布': 'News Release',
    '编辑学校简介': 'Edit School Introduction',
    '标记地理位置': 'Mark Geographic Location',
    '考勤管理': 'Attendance Management',
    '门禁规则（旧）': 'Access Control Rules (Old)',
    '考勤明细重算': 'Attendance Details Recalculation',
    '考勤率': 'Attendance Rate',
    '考勤管理(新版)': 'Attendance Management (New Version)',
    '考勤管理(旧版)': 'Attendance Management (Old Version)',
    '大屏轮播管理': 'Large Screen Carousel Management',
    '考勤标签管理': 'Attendance Tag Management',
    '考勤汇总': 'Attendance Summary',
    '考勤记录': 'Attendance Record',
    '签到二维码': 'Check-in QR Code',
    '考勤规则管理': 'Attendance Rule Management',
    '考勤规则管理(新版)': 'Attendance Rule Management (New Version)',
    '考勤规则管理(旧版)': 'Attendance Rule Management (Old Version)',
    '考勤明细': 'Attendance Details',
    '考勤明细(新版)': 'Attendance Details (New Version)',
    '考勤明细(旧版)': 'Attendance Details (Old Version)',
    '人脸识别功能管理': 'Facial Recognition Function Management',
    '人脸库管理': 'Face Library Management',
    '识别记录（仅考勤）': 'Recognition Record (Only Attendance)',
    '服务管理(新版)': 'Service Management (New Version)',
    '识别记录(新版)': 'Recognition Record (New Version)',
    '推送限制': 'Push Limitation',
    '校园缴费': 'Campus Payment',
    '职工消费统计': 'Employee Consumption Statistics',
    '系统设置': 'System Settings',
    '审核': 'Audit',
    '毕业管理': 'Graduation Management',
    '图片加载失败': 'Failed to Load Image',
    '验证码不正确，请重新刷新': 'Incorrect Verification Code, Please Refresh',
    '账号密码错误，还剩余4次输入机会': 'Account Password Error, Still 4 Attempts Left',
    '账号密码错误，还剩余3次输入机会': 'Account Password Error, Still 3 Attempts Left',
    '账号密码错误，还剩余2次输入机会': 'Account Password Error, Still 2 Attempts Left',
    '账号密码错误，还剩余1次输入机会': 'Account Password Error, Only 1 Attempt Left',
    '请先输入用户名': 'Please Enter Username First',
    '请先输入密码': 'Please Enter Password First',
    '请输入验证码': 'Please Enter Verification Code',
    '验证码': 'Verification Code',
    '当前账号的密码是弱密码，请联系运营人员修改': 'The current account password is weak, please contact the operator to change it',
    '验证码不存在': 'Verification Code Does Not Exist',
    '编辑考试': 'Edit Exam',
    '学生成绩需要通过表格形式导入，点击此处': 'Student Grades Need to Be Imported via Table, Click Here',
    '导入成绩': 'Import Grades',
    '学生录入情况': 'Student Entry Status',
    '成绩汇总': 'Grade Summary',
    '导入方式:': 'Import Method:',
    '按学生id': 'By Student ID',
    '按学生姓名': 'By Student Name',
    '导入成绩需要按照模板格式填入数据，否则将导入失败，点击': 'Grades need to be entered according to template format, otherwise import will fail, click',
    '导入名单:': 'Import List:',
    '导入': 'Import',
    '表格导入成功': 'Table Import Successful',
    '人，导入失败': 'Person, Import Failed',
    '下载导入失败名单': 'Download Failed Import List',
    '填写须知:': 'Instructions:',
    '1、请按照表格模板中的名单进行成绩的录入，支持调整表格中学生的顺序，系统将通过姓名、年级、班级3个字段进行学生成绩的匹配': '1, Please enter grades according to the list in the table template, support adjusting the order of students in the table, the system matches student grades through three fields: name, grade, class',
    '2、若表格中同个班级存在相同姓名的学生，则系统将随机匹配该学生成绩，请在表格导入后于管理平台上自行修改相同姓名的学生成绩': '2, If there are students with the same name in the same class in the table, the system will randomly match their grades, please modify the grades of students with the same name on the management platform after importing the table',
    '3、按照下载的模板填入相应的数据，请勿修改字段的位置和删减字段': '3, Fill in the corresponding data according to the downloaded template, do not modify the position of the field and delete any fields',
    '4、是否缺考字段默认选择“否”。若选择"是", 则各科分数可不填': '4, The "Did Not Attend" field defaults to "No". If selected as "Yes", scores for each subject can be omitted',
    '5、分数格式有“数字”、“-”和“缺考”3种。“数字”即为该科的分值，“-”表示特殊情况不计该科成绩，“缺考”表示单科缺考': '5, Score formats include "Number", "-" (minus), and "Absent". "Number" is the score of the subject, "-" indicates special cases where the subject score is not counted, "Absent" means absent from one subject',
    '6、填入的分数不得超过该科最高分值': '6, The entered score cannot exceed the highest score of the subject',
    '7、可在表格最右侧增加备注字段': '7, Comments can be added at the far right of the table',
    '（不可在原字段中间插入其他字段），导入时不录入数据库': '(Cannot insert other fields in the original field), does not record in the database during import',
    '是否缺考': 'Did Not Attend',
    '语文': 'Chinese',
    '数学': 'Mathematics',
    '获取成绩导入班级失败, 请刷新重试': 'Failed to Get Grade Import Class, Please Refresh and Try Again',
    '数据库中该班级没有学生': 'There Are No Students in This Class in the Database',
    '成绩导入完成': 'Grade Import Completed',
    '成绩录入失败，请重新上传': 'Failed to Record Grades, Please Upload Again',
    '成绩录入失败了，请重新上传！': 'Failed to Record Grades, Please Upload Again!',
    '获取成绩详情失败, 请刷新重试': 'Failed to Retrieve Grade Details, Please Refresh and Try Again',
    '执行中...': 'Processing...',
    '模板下载中...': 'Template Downloading...',
    '模板下载成功': 'Template Download Successful',
    '没有导出失败的学生': 'No Failed Exported Students',
    '表格上传中...': 'Table Uploading...',
    '请检查导入表格数据是否为空': 'Please Check If the Imported Table Data Is Empty',
    '表格导入成功,请提交': 'Table Import Successful, Please Submit',
    '表格数据处理失败,请刷新重试': 'Table Data Processing Failed, Please Refresh and Try Again',
    '请勿修改模板表头': 'Do Not Modify Template Headers',
    '字段值、位置或删减，按模板重新导入！': 'Field Values, Positions, or Deletions, Re-import According to the Template!',
    '请填写除模板示例外要导入的学生数据': 'Please Fill In Additional Student Data Except for Template Examples',
    '请按模板填写第': 'Please Fill In the Following According to the Template',
    '位学生的“是否缺考”信息': 'Information About Whether the Student Did Not Attend',
    '位学生的': 'Of the Student',
    '第': 'The',
    '成绩不能为负数，请重新填写': 'Scores Cannot Be Negative, Please Rewrite',
    '位学生正确的': 'Correct for the Student',
    '成绩格式': 'Score Format',
    '分数超过该科最高分值': 'Score Exceeds the Highest Possible Score for the Subject',
    '分，请修改重新导入': 'Score, Please Modify and Re-import',
    '信息': 'Information',
    '请勿删除或修改模板表头姓名字段等信息，请重新导入': 'Do Not Delete or Modify Information Such as Name Field in Template Header, Please Re-import',
    '请勿删除或修改模板表头id,姓名字段等信息，请重新导入': 'Do Not Delete or Modify Information Such as id, Name Field in Template Header, Please Re-import',
    '表格导入数据失败,请刷新重试': 'Table Data Import Failed, Please Refresh and Try Again',
    '数据上传中...': 'Data Uploading...',
    '请先选择文件上传表格': 'Please Select File to Upload Table',
    '成绩导入': 'Grade Import',
    '人，已录入': 'Person, Already Entered',
    '人。': 'Person.',
    '系统id': 'System ID',
    '请先保存当前编辑项': 'Please Save the Current Edit Item First',
    '编辑学生成绩失败, 请重新编辑': 'Failed to Edit Student Grades, Please Edit Again',
    '保存成功!': 'Saved Successfully!',
    '人，未录入': 'Person, Not Entered',
    '考试人数:': 'Number of Test Takers:',
    '+附件上传': '+ Attachment Upload',
    '规则设置': 'Rule Settings',
    '幼儿园刷卡机': 'Kindergarten Card Reader',
    '3G车载设备': '3G Vehicle Equipment',
    '测温枪': 'Thermometer Gun',
    '消费设备': 'Consumption Device',
    '访客设备': 'Visitor Device',
    '中小学刷卡机': 'Elementary and Middle School Card Reader',
    '闸门设备': 'Gate Device',
    '摄像头': 'Camera',
    '中小学刷卡机2代': 'Elementary and Middle School Card Reader 2nd Generation',
    '大屏指纹机': 'Large Screen Fingerprint Machine',
    '无障碍通道': 'Barrier-free Passage',
    '彩色小摆闸': 'Colorful Small Turnstile',
    '4G车载设备': '4G Vehicle Equipment',
    '卧式消费机': 'Horizontal Consumption Machine',
    '人脸识别摄像头': 'Facial Recognition Camera',
    '慧星人脸摄像头': 'Wisdom Star Facial Recognition Camera',
    '电子班牌': 'Electronic Class Board',
    '锐目人脸': 'Sharp Eye Facial Recognition',
    '中晖人脸摄像头': 'Zhonghui Facial Recognition Camera',
    '路由器设备': 'Router Device',
    '卧式消费机(CPU卡)': 'Horizontal Consumption Machine (CPU Card)',
    '挂式消费机': 'Hanging Consumption Machine',
    '人脸识别闸门': 'Facial Recognition Turnstile',
    '触控一体机': 'Touch Screen All-in-One Machine',
    '人脸识别主机': 'Facial Recognition Host',
    '报警主机': 'Alarm Host',
    '人脸识别盒子': 'Facial Recognition Box',
    '圆柱单目人脸识别机': 'Cylindrical Monocular Facial Recognition Machine',
    '接警主机': 'Police Alarm Host',
    '人脸识别车载APP': 'Facial Recognition Vehicle APP',
    '人脸识别闸门2代': 'Facial Recognition Turnstile 2nd Generation',
    '人脸识别车载2代': 'Facial Recognition Vehicle 2nd Generation',
    '食堂团餐设备': 'Canteen Group Meal Equipment',
    '推流盒子(Android)': 'Streaming Box (Android)',
    '自助售货机': 'Self-service Vending Machine',
    '自助售货机（服务端）': 'Self-service Vending Machine (Server Side)',
    '公安人脸摄像头': 'Public Security Facial Recognition Camera',
    '4G车载3代': '4G Vehicle 3rd Generation',
    '人脸识别消费盒子': 'Facial Recognition Consumption Box',
    '人脸识别消费机': 'Facial Recognition Consumption Machine',
    '推流盒子(Linux)': 'Streaming Box (Linux)',
    '人脸识别出租屋': 'Facial Recognition Rental Housing',
    '挂式消费机2代': 'Hanging Consumption Machine 2nd Generation',
    '消费盒子(Linux)': 'Consumption Box (Linux)',
    '人脸识别闸门A': 'Facial Recognition Turnstile Type A',
    '横版人脸识别消费机': 'Horizontal Facial Recognition Consumption Machine',
    '宿舍人脸识别闸门': 'Dormitory Facial Recognition Turnstile',
    '人脸识别闸门2代A': 'Facial Recognition Turnstile 2nd Generation Type A',
    '第三方设备考勤': 'Third-party Device Attendance',
    '横版人脸识别团餐消费机': 'Horizontal Facial Recognition Group Meal Consumption Machine',
    '巡检推流盒子(Linux)': 'Patrol Streaming Box (Linux)',
    'SE智能行为识别盒子': 'SE Intelligent Behavior Recognition Box',
    '自助售货机(农夫山泉)': 'Self-service Vending Machine (Nongfu Spring)',
    '校园亲情电话-A': 'Campus Affectionate Call-A',
    '推流盒子(Linux)-2代': 'Streaming Box (Linux) - 2nd Generation',
    '消费盒子(Linux)-2代': 'Consumption Box (Linux) - 2nd Generation',
    '校园亲情电话-B': 'Campus Affectionate Call-B',
    '校园亲情电话-C': 'Campus Affectionate Call-C',
    '人脸识别闸门L-1代': 'Facial Recognition Turnstile L-1st Generation',
    '人脸识别考勤APP': 'Facial Recognition Attendance APP',
    '批量录入详情': 'Bulk Input Details',
    '_学生_批量录入结果_': '_Student Bulk Input Result_',
    '_职工_批量录入结果_': '_Employee Bulk Input Result_',
    '_家长_批量录入结果_': '_Parent Bulk Input Result_',
    ',请重新导出': ',Please Export Again',
    '清除': 'clear',
    '1、当前支持的设备': '1. Currently supported devices',
    '2、其他设备': '2. Other devices',
    '"学生、职工、家长"中的3个筛选项，请至少选填1项': 'Please select at least one of the three options: "Student", "Staff", or "Parent"',
    '职位管理': 'Position Management',
    '系统管理员': 'System Administrator',
    '中文': 'Chinese',
    'English': 'English',
    'Malaysia': 'Malaysia',
    '萌萌圈评论审核列表': 'Momo Circle Comment Review List',
    '学校自主审核列表': 'School self-review list',
    '单元': 'element',
    '缺考': 'Absent',
    '分数格式错误': 'Score Format Error',
    '示例（可删除）': 'Example (Removable)',
    '③填写表格时， 请勿修改“系统ID、手机主号、年级、班级、学生姓名”。': '③ When filling out the form, please do not modify "system ID, mobile phone number, grade, class, student name".',
    '④对于已录入照片的学生，重新录入的话，新照片将会覆盖旧照片。': '④ For students who have already entered photos, if they re-enter, the new photos will overwrite the old photos.',
    '选择的用户类型或上传的人脸照片匹配表有误': 'The selected user type or uploaded facial photo matching table is incorrect',
    ',请刷新后重试' : ',Please refresh and try again',
    '备注': 'Remarks',
    '健康管理': 'Health Management',
    '健康日报': 'Health Daily',
    '选择时段': 'Select time period',
    '角色类型': 'Role type',
    '选择状态': 'Select status',
    '正常': 'normal',
    '异常': 'abnormal',
    '职位': 'position',
    '测温时段': 'Temperature measurement period',
    '温度': 'temperature',
    '获取老师体温列表失败, 请刷新重试': 'Failed to obtain the teacher\'s temperature list, please refresh and try again',
    '获取学生体温列表失败, 请刷新重试': 'Failed to obtain the student temperature list, please refresh and try again',
    '获取时段列表失败, 请刷新重试': 'Failed to obtain the time period list, please refresh and try again',
    ', 请刷新重试': ', please refresh and try again',
    '未填写照片名称，默认不进行任何处理': 'If the photo name is not filled in, no processing will be performed by default',
    '用户人脸已经存在，请先删除再上传': 'The user\'s face already exists, please delete it before uploading it',
    '使用帮助' : 'Help',
    '帮助详情' : 'Help details',
    '英语': 'English',
    '物理': 'physics',
    '化学': 'chemistry',
    '生物': 'biology',
    '地理': 'geography',
    '政治': 'politics',
    '历史': 'history',
    '体育': 'sport',
    '音乐': 'music',
    '美术': 'the fine arts',
    '文综': 'Literary Comprehensive',
    '信息技术': 'information technology',
    '文科综合': 'Humanities Comprehensive',
    '理科综合': 'comprehensive science',
    '职工ID': 'Employee ID',
    '已经有任务正在进行': 'There are already tasks in progress',
    '当前表格为空': 'The current table is empty',
    '下载人脸照片采集说明地址': 'https://xbullyun.x-bull.com/app_agreement/Facial%20Photo%20Collection%20Guidelines.docx',
    '请求错误': 'Request Error',
    '服务器内部错误，请联系管理员': 'Internal server error, please contact the administrator',
    '登录已过期， 请重新登陆': 'Login has expired, please log in again',
    '请求失败,请刷新重试': 'Request failed, please refresh and retry',
    '请勿重复设置，门禁规则“': 'Please do not repeat the settings, the access control rule "',
    '”已经设置过': '" has already been set',
    '的家长': '\'s parents',
    '人脸照片过小，请重新用高像素相机或靠近拍照上传': 'The face photo is too small. Please upload it again with a high-pixel camera or take a closer photo',
    '人脸读取失败，请确定图片可以正常访问': 'Face reading failed, please make sure the image can be accessed normally',
    '图片内人脸数量过多，识别失误，请重新拍照上传': 'There are too many faces in the picture, and the recognition failed. Please take a new photo and upload it',
    '图片检测不合格，请重新拍照上传': 'The image detection failed, please take a new photo and upload it',
    '眼睛或眉毛被遮挡，请重新拍照上传': 'Eyes or eyebrows are blocked, please take a new photo and upload it',
    '鼻子被遮挡，请重新拍照上传': 'The nose is blocked, please take a new photo and upload it',
    '嘴巴被遮挡，请重新拍照上传': 'The mouth is blocked, please take a new photo and upload it',
    '左脸颊被遮挡，请重新拍照上传': 'The left cheek is blocked, please take a new photo and upload it',
    '右脸颊被遮挡，请重新拍照上传': 'The right cheek is blocked, please take a new photo and upload it',
    '光线过暗，请重新拍照上传': 'The light is too dark, please take a new photo and upload it',
    '光线过亮，请重新拍照上传': 'The light is too bright, please take a new photo and upload it',
    '头部过于低，请重新拍照上传': 'The head is too low, please take a new photo and upload it',
    '头部过于昂，请重新拍照上传': 'The head is too high, please take a new photo and upload it',
    '头部过于左倾，请重新拍照上传': 'The head is too tilted to the left, please take a new photo and upload it',
    '头部过于右倾，请重新拍照上传': 'The head is too tilted to the right, please take a new photo and upload it',
    '头部过于左偏，请重新拍照上传': 'The head is too tilted to the left, please take a new photo and upload it',
    '头部过于右偏，请重新拍照上传': 'The head is too tilted to the right, please take a new photo and upload it',
    '人脸过于模糊，请重新拍照上传': 'The face is too blurry, please take a new photo and upload it',
    '人脸轮廓不够完整，请重新拍照上传': 'The facial outline is not complete, please take a new photo and upload it',
    '活体检测未通过，请重新拍照上传': 'The liveness test failed. Please take a new photo and upload it',
    '该人脸已经存在，请不要重复上传': 'This face already exists, please do not upload it again',
    '找不到上传记录': 'Upload record not found',
    '人脸校验token未找到，请先校验人脸': 'Face verification token not found, please verify face first',

};
